/* eslint-disable arrow-body-style */
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../tornado/utils/sizes';
import { getContentPadding } from '../layout/abstractLayout.style';
import { createBlock } from './exploreCatalogue.utils';
import { colors } from './exploreCatalogue.constants';

export const defaultContext = makeDefaultStylingContext();

export const MARGIN_BLOCKS_TOP = {
  [HD]: 24,
  [FULL_HD]: 40,
};

export const MARGIN_TITLE_TOP = {
  [HD]: 40,
  [FULL_HD]: 48,
};

export const MARGIN_DESCRIPTION_TOP = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const MARGIN_SCREEN_TITLE_TOP = {
  [HD]: 168,
  [FULL_HD]: 272,
};

export const BLOCK_WIDTH = {
  [HD]: 221,
  [FULL_HD]: 327,
};

export const BLOCK_HEIGHT = {
  [HD]: 124,
  [FULL_HD]: 184,
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  return {
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode],
    },
    Content: {
      x: getContentPadding(),
      flex: { direction: 'column' },
      MainTitle: {
        flexItem: { marginTop: MARGIN_SCREEN_TITLE_TOP[screenSize] },
        text: {
          ...getFont(FONT.PARIS_3, screenSize),
        },
      },
      Blocks: {
        flexItem: { marginTop: colors.blocks.length ? MARGIN_BLOCKS_TOP[screenSize] : 0 },
        flex: {},
        children: colors.blocks.map(color => createBlock(color, screenSize, colorMode)),
      },
      Title: {
        flexItem: { marginTop: MARGIN_TITLE_TOP[screenSize] },
        text: {
          ...getFont(FONT.OTTAWA_3, screenSize),
        },
      },
      Description: {
        flexItem: { marginTop: MARGIN_DESCRIPTION_TOP[screenSize] },
        text: {
          ...getFont(FONT.BERLIN_1, screenSize),
        },
      },
      Button: {
        flexItem: { marginTop: MARGIN_TITLE_TOP[screenSize] },
      },
    },
  };
};
